// JSON-LD builders. Every value comes from src/data/profile.js.
// Plain module (no React) so tests can import it; render with <StructuredData data={...} />.
import { identity, contact, services, career, education } from '../data/profile.js'

const SITE_URL = identity.website
// Pages link to Martin by this id; Home and About render personSchema() so it resolves.
export const PERSON_ID = `${SITE_URL}/#person`
export const SERVICE_ID = `${SITE_URL}/#service`

const unique = (values) => [...new Set(values)]

/**
 * Martin as a Person. Every value comes from src/data/profile.js.
 */
export function personSchema() {
  const current = career.filter((c) => c.end === null)
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    '@id': PERSON_ID,
    name: identity.name,
    url: SITE_URL,
    image: `${SITE_URL}/martin-headshot.jpg`,
    email: contact.email,
    jobTitle: current.map((c) => c.role),
    worksFor: current.map((c) => ({ '@type': 'Organization', name: c.employer })),
    alumniOf: unique(education.filter((e) => !e.inProgress).map((e) => e.institution)).map((name) => ({
      '@type': 'CollegeOrUniversity',
      name,
    })),
    sameAs: identity.sameAs,
  }
}

/**
 * The consulting practice. No prices (BRIEF: no prices on the site).
 */
export function professionalServiceSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    '@id': SERVICE_ID,
    name: identity.name,
    url: SITE_URL,
    email: contact.email,
    image: `${SITE_URL}/martin-headshot.jpg`,
    founder: { '@id': PERSON_ID },
    address: { '@type': 'PostalAddress', addressCountry: 'EE' },
    areaServed: { '@type': 'Place', name: 'European Union' },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Services',
      itemListElement: services.map((s) => ({
        '@type': 'Offer',
        itemOffered: { '@type': 'Service', name: s.name, url: `${SITE_URL}${s.path}` },
      })),
    },
  }
}
